module.exports = __webpack_public_path__ + "static/img/apple-icon-167x167.tid2.baad74f.png";